import { Directive } from '@angular/core';
import { CheckoutFormComponentDef } from '@df/checkout/checkout-form.component.def';

@Directive()
export abstract class CheckoutAccountStatusComponentDef {
    /**
     * Class constructor
     */
    constructor(protected checkoutFormComponent: CheckoutFormComponentDef) {}

    /**
     * Email shorthand
     */
    get email(): string | undefined {
        return this.checkoutFormComponent.email;
    }

    /**
     * Change email and go to step of given name
     */
    change(stepName: string = 'account') {
        // switch of guest checkout
        this.checkoutFormComponent.toggleGuestCheckout(false);
        this.checkoutFormComponent.goToStep(stepName);
    }
}
